import React from "react";
import BuyService from "../../../../Common/StripeForms/BuyService";

const Payment = ({ serviceParams, appointmentData, host, objName, price, slots, addOn }: { 
  serviceParams: any, 
  appointmentData: any, 
  host: any, 
  objName: any,
  price: any,
  slots: any,
  addOn: any
}) => {
  return (
    <div>
      <div className="step-innercontent step5 payment-step5">
        <div className="consult-section-heading text-center mb-4">
          <h3>Complete Payment</h3>
        </div>
        
        <div className="payment-form-container">
          <BuyService serviceParams={serviceParams} />
        </div>
      </div>
    </div>
  );
};

export default Payment;
